/**
 * Strip Unicode combining marks relevant to this codebase:
 *   - Latin combining diacritics: U+0300–U+036F
 *   - Hebrew te'amim (cantillation) and niqqud (vowel points): U+0591–U+05C7
 *
 * Useful for diacritic-insensitive search where the user types base letters
 * but the data may contain pointed text (e.g. ניקוד / טעמים).
 *
 * Uses explicit ranges instead of `\p{M}` so the regex compiles under both the
 * client and server tsconfig targets without the `u` flag.
 */
export function stripCombiningMarks(s: string): string {
  return s.normalize('NFD').replace(/[̀-֑ͯ-ׇ]/g, '')
}

/**
 * Normalize a string for diacritic-insensitive, case-insensitive matching.
 * For Hebrew that means: niqqud and te'amim are stripped; the rest stays.
 */
export function normalizeForSearch(s: string): string {
  return stripCombiningMarks(s).toLowerCase().trim()
}
